import { Link } from "react-router-dom";
import tw from "twin.macro";

const SidebarContainer = tw.div`w-64 bg-primary-900 text-white min-h-screen p-6`;
const NavLink = tw(Link)`block py-2 px-4 rounded hover:bg-primary-700 transition duration-300`;

export default function Sidebar() {
  return (
    <SidebarContainer>
      <h2 tw="text-xl font-bold mb-6">Admin Panel</h2>
      <nav>
        <NavLink to="/admin">Dashboard</NavLink>
        <NavLink to="/admin/users">Users</NavLink>
        <NavLink to="/admin/donations">Donations</NavLink>
      </nav>
    </SidebarContainer>
  );
}
